export class LessonExtraLite {
    id : number;
    name : string;
    slug : string;
    duration: number;
    order: number;
    course_module_id: number;
}